import React from "react";
import styled from "@emotion/styled";
import ServiceWrapper from "../components/ServiceWrapper";
import { track } from "../utils/track";

/**
 * 사용법 영상 (2026-10-11 사장님: 유튜브 '코드스코어 사용법' 재생목록, 메뉴에서 연결).
 * 영상 번호는 유튜브에 올린 뒤 tools/promo/work/out/youtube_howto.json 의 videoId 를 여기 채운다 (빈 칸은 재생목록으로).
 */
const PLAYLIST = "https://www.youtube.com/playlist?list=PLTrLloR9uFkU";

const VIDEOS: { n: number; title: string; desc: string; id?: string }[] = [
  { n: 1, title: "악보 보기 기본", desc: "악보 열기 · 자동 스크롤 · 속도 · 키", id: "ElXJh3Z0sBI" },
  { n: 2, title: "마디 보기 · 가사 보기", desc: "보기 방식과 연주 모드", id: "5oyFquJ8MiA" },
  { n: 3, title: "쉬운 코드", desc: "카포 추천 · 코드 단순하게", id: "98hhUtnXZag" },
  { n: 4, title: "반주 · 메트로놈", desc: "기타 반주와 박자 맞추기", id: "YEGUntFGY4M" },
  { n: 5, title: "연주 체크", desc: "마이크로 듣고 맞게 치는지 알려 줘요", id: "Yt3Em-ak0Ok" },
  { n: 6, title: "원곡 영상", desc: "원곡을 들으며 같이 연습", id: "IoM-eW0p6j8" },
  { n: 7, title: "튜너", desc: "기타 · 우쿨렐레 줄 맞추기", id: "jsSWEV1-HNA" },
  { n: 8, title: "핫클립", desc: "인기 기타 연주 영상", id: "holoqud3TPI" },
  { n: 9, title: "악보 찾기", desc: "검색 · 인기 TOP 100 · 새 악보", id: "hGUb3aUSrto" },
  { n: 10, title: "신청 · 문의", desc: "없는 곡 신청과 문의하기", id: "URr7r_030lY" },
  { n: 11, title: "내 악보 만들기", desc: "유튜브 주소로 AI 가 코드 악보를" },
  { n: 12, title: "합주방", desc: "링크로 친구와 같은 악보를 같이" },
  { n: 13, title: "연주목록", desc: "자주 치는 곡 담아 두기" },
];

const Howto: React.FC = () => (
  <ServiceWrapper isFooterRendered={false}>
    <Page>
      <h1>사용법</h1>
      <p>짧은 영상으로 코드스코어 기능을 알려 드려요.</p>
      <All href={PLAYLIST} target="_blank" rel="noopener noreferrer" onClick={() => track("howto:playlist")}>
        유튜브에서 전체 보기 ›
      </All>
      <List>
        {VIDEOS.map((v) => (
          <Item
            key={v.n}
            href={v.id ? `https://www.youtube.com/watch?v=${v.id}&list=PLTrLloR9uFkU` : PLAYLIST}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track(`howto:${v.n}`)}
          >
            <Thumb style={v.id ? { backgroundImage: `url(https://i.ytimg.com/vi/${v.id}/mqdefault.jpg)` } : undefined}>
              <b>{v.n}</b>
            </Thumb>
            <div>
              <strong>{v.title}</strong>
              <span>{v.id ? v.desc : `${v.desc} · 곧 올라와요`}</span>
            </div>
          </Item>
        ))}
      </List>
    </Page>
  </ServiceWrapper>
);

export default Howto;

const Page = styled.div`
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 24px 20px 110px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  color: #f3f4f6;
  & > h1 {
    margin: 0;
    font-size: 26px;
    font-weight: 800;
  }
  & > p {
    margin: -6px 0 0;
    font-size: 15px;
    color: #a3a9b5;
  }
`;

const All = styled.a`
  align-self: flex-start;
  font-size: 14px;
  font-weight: 700;
  color: #ffb547;
  text-decoration: none;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.a`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px;
  border-radius: 14px;
  background: #16181e;
  border: 1px solid #2a2e38;
  text-decoration: none;
  color: inherit;
  & > div {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  & strong {
    font-size: 16px;
    color: #f3f4f6;
  }
  & span {
    font-size: 13px;
    color: #a3a9b5;
    word-break: keep-all;
  }
`;

const Thumb = styled.span`
  flex: none;
  position: relative;
  width: 96px;
  height: 54px;
  border-radius: 10px;
  background: #1f222a center / cover no-repeat;
  & > b {
    position: absolute;
    left: 6px;
    bottom: 4px;
    padding: 1px 6px;
    border-radius: 6px;
    background: #ffb547;
    color: #0d0e12;
    font-size: 12px;
  }
`;
